<template>
  <div>
    <el-card shadow="hover">
      <template slot="header">
        <div class="clearfix">
          <span>客户标签管理</span>
          <span class="muted small" style="margin-left:10px">维护客户可选的标签项</span>
          <div style="float: right">
            <el-button type="primary" size="small" icon="el-icon-plus" @click="openDialog()">新建标签</el-button>
          </div>
        </div>
      </template>

      <el-table :data="labels" stripe size="small" border v-loading="loading" @row-dblclick="row => openDialog(row)">
        <el-table-column label="排序" prop="sort" width="80" align="center"></el-table-column>
        <el-table-column label="标签名称" min-width="160">
          <template slot-scope="{ row }">
            <el-tag :color="row.color || ''" :style="row.color ? 'color:#fff;border-color:' + row.color : ''" size="small">{{ row.name }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="颜色" width="120" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.color" :style="'display:inline-block;width:18px;height:18px;border-radius:3px;background:'+row.color+';vertical-align:middle;margin-right:6px'"></span>
            <span class="muted">{{ row.color || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="{ row }">
            <el-tag size="mini" :type="row.enabled === 1 ? 'primary' : 'info'" effect="plain">{{ row.enabled === 1 ? '启用' : '停用' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="remark" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column label="创建时间" width="160" align="center">
          <template slot-scope="{ row }">{{ formatDate(row.createTime) }}</template>
        </el-table-column>
        <el-table-column label="ID" prop="id" width="80" align="center"></el-table-column>
        <el-table-column label="操作" width="160" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button size="mini" type="primary" @click="openDialog(row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="onDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog :title="form.id ? '编辑标签' : '新建标签'" :visible.sync="dialogVisible" width="880px" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form :model="form" :rules="rules" ref="form" label-width="90px">
        <el-form-item label="标签名称" prop="name">
          <el-input v-model="form.name" placeholder="如 VIP、潜在客户、流失等" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="颜色">
          <el-color-picker v-model="form.color"></el-color-picker>
          <span class="muted small" style="margin-left:10px">用于列表显示标签底色</span>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sort" :min="0" :step="1" style="width:100%"></el-input-number>
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="form.enabled" :active-value="1" :inactive-value="0" active-text="启用" inactive-text="停用"></el-switch>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" :rows="2" maxlength="500" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="onSubmit" :loading="submitting">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'CustomerLabel',
  data() {
    return {
      labels: [],
      loading: false,
      dialogVisible: false,
      submitting: false,
      form: this.emptyForm(),
      rules: {
        name: [{ required: true, message: '请输入标签名称', trigger: 'blur' }]
      }
    }
  },
  mounted() { this.loadList() },
  methods: {
    emptyForm() {
      return { id: null, name: '', color: '', sort: 0, enabled: 1, remark: '' }
    },
    loadList() {
      this.loading = true
      axios.get('/customer-label/list').then(res => {
        this.labels = Array.isArray(res.data) ? res.data : []
      }).finally(() => { this.loading = false })
    },
    openDialog(row) {
      this.form = row ? { ...row } : this.emptyForm()
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.submitting = true
        const req = this.form.id ? axios.put('/customer-label', this.form) : axios.post('/customer-label', this.form)
        req.then(res => {
          if (res.data && res.data.success !== false) {
            this.$message.success(this.form.id ? '更新成功' : '新建成功')
            this.dialogVisible = false
            this.loadList()
          } else {
            this.$message.error((res.data && res.data.message) || '保存失败')
          }
        }).finally(() => { this.submitting = false })
      })
    },
    onDelete(row) {
      this.$confirm('确定删除标签「' + row.name + '」吗？', '提示', { type: 'warning' }).then(() => {
        axios.delete('/customer-label/' + row.id).then(res => {
          if (res.data && res.data.success !== false) {
            this.$message.success('删除成功')
            this.loadList()
          } else {
            this.$message.error((res.data && res.data.message) || '删除失败')
          }
        })
      }).catch(() => {})
    },
    formatDate(v) { return v ? String(v).replace('T', ' ').slice(0, 10) : '-' }
  }
}
</script>

<style scoped>
.muted { color: #909399; }
.small { font-size: 12px; }
</style>
